import {Injectable} from '@angular/core';
import {NetworkConfiguration} from '../../../../../models-monitoring';
import {KluhManagerValidator} from '../../../../../validators/kluh-manager-validator';
import {BaseSearchDao} from '../../../../../base-search-dao';
import {Observable} from 'rxjs/internal/Observable';
import {ServerType} from '../../../../../models';
import {R2CloudHttpMonitoringService} from '../../../../../r2-cloud-http-monitoring.service';

@Injectable({
    providedIn: 'root'
})
export class NetworkConfigurationDaoService extends BaseSearchDao<NetworkConfiguration> {
    constructor(http: R2CloudHttpMonitoringService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'network-configuration');
    }

    findAllByServerIdAndServerType(serverId: number, serverType: ServerType): Observable<NetworkConfiguration[]> {
        return this.http.get<NetworkConfiguration[]>(this.url + '/find-all-by-server-id-and-server-type/' + serverType + '/' + serverId);
    }
}
